import { Replace } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from 'shadcn/components/ui/Dialog';

/**
 * Confirmation dialog before updating substitutions on a batch.
 * @param {object} props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {(open: boolean) => void} props.onOpenChange - Dialog open/close handler
 * @param {() => void} props.onConfirm - Called when the operator confirms
 * @param {number} [props.batchCount=1] - Number of batches being submitted
 * @returns {JSX.Element}
 */
export function ApplySubstitutionsConfirmDialog({ batchCount = 1, onConfirm, onOpenChange, open }) {
    const isMultiBatch = batchCount > 1;
    const title = isMultiBatch ? `Update Substitutions for ${batchCount} Batches?` : 'Update Substitutions?';

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Replace className="h-5 w-5" aria-hidden="true" />
                        {title}
                    </DialogTitle>
                    <DialogDescription>
                        Applies or removes substitution rules that were enabled or disabled after{' '}
                        {isMultiBatch ? 'these batches were' : 'this batch was'} printed, for eligible orders in{' '}
                        {isMultiBatch ? 'the selected batches' : 'the batch'}.
                    </DialogDescription>
                </DialogHeader>
                <ul className="list-disc space-y-2 pl-5 text-sm text-foreground">
                    <li>Skips shipments that are already Packed</li>
                </ul>
                <DialogFooter className="gap-2">
                    <Button variant="outline" onClick={() => onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm}>Update Substitutions</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

ApplySubstitutionsConfirmDialog.displayName = 'ApplySubstitutionsConfirmDialog';
